var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.skin !== 'dark')?_c('b-img',{attrs:{"width":"210px","src":require("@/assets/images/logo-text-black.png")}}):_c('b-img',{attrs:{"width":"210px","src":require("@/assets/images/logo-text-white.png")}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }